// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.password-reset-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-secondary);
}

.password-reset-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: var(--bg-primary);
  border-bottom: 1px solid var(--border-color);
  position: relative;
}

.password-reset-back {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: var(--bg-tertiary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: var(--text-primary);
  transition: all var(--transition-fast);
  line-height: 1;
}

.password-reset-back:hover {
  background: var(--border-color);
}

.password-reset-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.password-reset-body {
  flex: 1 1;
  padding: 24px;
}

.password-reset-form {
  display: flex;
  flex-direction: column;
}

.password-reset-label {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.password-reset-label:not(:first-child) {
  margin-top: 16px;
}

.password-reset-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid var(--border-color);
  border-radius: var(--radius-md);
  font-size: 15px;
  font-family: inherit;
  background: var(--bg-primary);
  color: var(--text-primary);
  transition: all var(--transition-fast);
}

.password-reset-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 4px rgba(8, 145, 178, 0.1);
}

.password-reset-input::placeholder {
  color: var(--text-muted);
}

/* 空三行 */
.password-reset-spacer {
  height: 72px;
}

.password-reset-submit {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, var(--primary-color), var(--info-color));
  color: white;
  border: none;
  border-radius: var(--radius-md);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-base);
}

.password-reset-submit:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.password-reset-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.password-reset-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 24px;
}

.password-reset-modal {
  background: var(--bg-primary);
  border-radius: var(--radius-lg);
  padding: 32px;
  width: 100%;
  max-width: 360px;
  text-align: center;
  box-shadow: var(--shadow-xl);
  animation: slideUp var(--transition-slow);
}

.password-reset-modal-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-secondary);
  margin-bottom: 16px;
}

.password-reset-modal-password {
  font-size: 28px;
  font-weight: 800;
  letter-spacing: 2px;
  color: var(--text-primary);
  background: var(--bg-secondary);
  border: 1px dashed var(--border-color);
  border-radius: var(--radius-md);
  padding: 16px;
  margin-bottom: 24px;
  word-break: break-all;
}

.password-reset-copy-btn {
  width: 100%;
  padding: 12px;
  background: linear-gradient(135deg, var(--primary-color), var(--info-color));
  color: white;
  border: none;
  border-radius: var(--radius-md);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-base);
}

.password-reset-copy-btn:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}`, "",{"version":3,"sources":["webpack://./src/PasswordResetPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,QAAQ;AACR;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,4EAA4E;EAC5E,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,+BAA+B;EAC/B,sCAAsC;EACtC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,4EAA4E;EAC5E,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B","sourcesContent":[".password-reset-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-secondary);\n}\n\n.password-reset-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  background: var(--bg-primary);\n  border-bottom: 1px solid var(--border-color);\n  position: relative;\n}\n\n.password-reset-back {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: none;\n  background: var(--bg-tertiary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  color: var(--text-primary);\n  transition: all var(--transition-fast);\n  line-height: 1;\n}\n\n.password-reset-back:hover {\n  background: var(--border-color);\n}\n\n.password-reset-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.password-reset-body {\n  flex: 1;\n  padding: 24px;\n}\n\n.password-reset-form {\n  display: flex;\n  flex-direction: column;\n}\n\n.password-reset-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.password-reset-label:not(:first-child) {\n  margin-top: 16px;\n}\n\n.password-reset-input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid var(--border-color);\n  border-radius: var(--radius-md);\n  font-size: 15px;\n  font-family: inherit;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  transition: all var(--transition-fast);\n}\n\n.password-reset-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 4px rgba(8, 145, 178, 0.1);\n}\n\n.password-reset-input::placeholder {\n  color: var(--text-muted);\n}\n\n/* 空三行 */\n.password-reset-spacer {\n  height: 72px;\n}\n\n.password-reset-submit {\n  width: 100%;\n  padding: 14px;\n  background: linear-gradient(135deg, var(--primary-color), var(--info-color));\n  color: white;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-base);\n}\n\n.password-reset-submit:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.password-reset-submit:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.password-reset-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 24px;\n}\n\n.password-reset-modal {\n  background: var(--bg-primary);\n  border-radius: var(--radius-lg);\n  padding: 32px;\n  width: 100%;\n  max-width: 360px;\n  text-align: center;\n  box-shadow: var(--shadow-xl);\n  animation: slideUp var(--transition-slow);\n}\n\n.password-reset-modal-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin-bottom: 16px;\n}\n\n.password-reset-modal-password {\n  font-size: 28px;\n  font-weight: 800;\n  letter-spacing: 2px;\n  color: var(--text-primary);\n  background: var(--bg-secondary);\n  border: 1px dashed var(--border-color);\n  border-radius: var(--radius-md);\n  padding: 16px;\n  margin-bottom: 24px;\n  word-break: break-all;\n}\n\n.password-reset-copy-btn {\n  width: 100%;\n  padding: 12px;\n  background: linear-gradient(135deg, var(--primary-color), var(--info-color));\n  color: white;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-base);\n}\n\n.password-reset-copy-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
